import {CertificateI18n} from '@/locales/base.message.locales';

export const certificates: CertificateI18n = {
  download_pdf: 'Baixar PDF',
  collaboration: {
    text_team: 'Certificamos que <strong>{user_name}</strong>, como membro da equipe <strong>{team_name}</strong>' +
      'participou do desafio <strong>{challenge_title}</strong> lançado e coordenado por ' +
      '<strong>{responsible_name}</strong> entre {accepted_at} à {closed_at}.',
    text_user: 'Certificamos que <strong>{user_name}</strong> participou do desafio <strong>{challenge_title}</strong> ' +
      'lançado e coordenado por <strong>{responsible_name}</strong> entre {accepted_at} à {closed_at}.',
    certificate: 'Certificado',
    challenge: 'Desafio',
    team: 'Time',
    issued: 'Emitido',
    valid: 'Válido',
    invalid: 'Inválido',
    no_certificate_found: 'Nenhum certificado encontrado!',
    text_verify_alert: 'Por sua segurança apenas o usuário logado pode ver este certificado.',
  }
};
